import React, { useEffect, useState } from 'react'
import Kotak from '../Images/kotak.svg'
import HDFC from "../Images/hdfc.svg"
import Paytm from "../Images/paytm.svg"
import backSpace from '../Images/Keyboard backspace.svg'
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import Lang from '../Images/lang.svg'
import EMandate from '../Images/EMandate.svg'
import UpiMandate from '../Images/UPIMandate.svg'
import AadhaarMandate from '../Images/AadharMandate.svg'
import PhysicalMandate from '../Images/PhysicalMandate.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import Digio from '../Images/digio.svg'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import { setLoggedIn, setMandate, setMandateData, setOtpTriggered, setShowLanguage, setmandateIdType, setPartnerName} from './MandateSlice'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import Loader from './Loader'

function MandateOpt() {
    const { mandateData, mandateID, partner } = useSelector((state) => state.mandateInfo);
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [showErr, setShowErr] = useState(false)
    const [loader, setLoader] = useState(true)
    const navigate = useNavigate()
    const { state } = useLocation();
    const mandateType = state?.mandateType
    const [type, setType] = useState()
    const mandateId = mandateID ? mandateID : sessionStorage.getItem("id")

    const checkOpt = () => {
        dispatch(setMandate(type))
        navigate('/mandate-options')
    }
    const logout = () => {
        dispatch(setOtpTriggered(false))
        dispatch(setLoggedIn(false))
        navigate('/login')
    }
    useEffect(() => {
        if (mandateId) {
            axios({
                url: process.env.REACT_APP_RESPONSE,
                method: 'post',
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': process.env.REACT_APP_API_KEY
                },
                data: { 'unique_id': mandateId }
            }).then((res) => {
                setLoader(false)
                if (res) {
                    dispatch(setMandateData(res?.data));
                    // New function (ARUN)
                    if (res?.data?.icici === true && res?.data?.upi_mandate === true && res?.data?.Source_Sys === "D2C" && res?.data?.e_mandate === false) {
                        dispatch(setMandate("upi-mandate"))
                        dispatch(setPartnerName("icici"))
                        dispatch(setmandateIdType('icici-upi-mandate'))
                        navigate("/upi-mandate")

                    }
                    // localStorage.setItem('id',res?.data?.unique_id)
                } else {
                    dispatch(setMandateData())
                }
            }).catch((e) => {
                setLoader(false)
                setShowErr(e?.message)
            });
        }
    }, [mandateId])
    return (
        // <div class="Banner">
        //     <div class="container Payment-way-page">
        //         <div class="row">
        //             <div class="col-12">
        //                 <a href="Language.html" class="Lang"><img src={Lang} /></a>
        //                 <div class="text-center brand">
        //                     <img src={cholaLogo} class="img-fluid mb-2" />
        //                     <p class="fw-semibold mb-5">Cholamandalam Investment and Finance Ltd</p>
        //                 </div>
        //             </div>
        //         </div>
        //         <div class="row">
        //             <div class="col-12 p-0">
        //                 <div class="contBg">
        //                     <h3 class="mt-2 mb-1">Welcome to <span class="text-danger">Mandate</span></h3>
        //                     <p class="text-secondary">Please select the <span class="fw-medium">Mandate Type</span></p>
        //                     <div className="row">
        // {mandateData?.upi_mandate && <div className="col-12 mb-3">
        //     <div className="d-flex justify-content-between align-items-center UPI_Mandate">
        //         <div className="form-check">
        //             <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('upi-mandate') }} />
        //             <label className="form-check-label" htmlFor="flexRadioDefault1"> {t('upimandate')} </label>
        //         </div>
        //         <div className="circleborder">   <img src={UpiMandate} /> </div>
        //     </div>
        // </div>}
        //                         {mandateData?.e_mandate && <div className="col-12 mb-3">
        //                             <div className="d-flex justify-content-between align-items-center UPI_Mandate">
        //                                 <div className="form-check">
        //                                     <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('e-mandate') }} />
        //                                     <label className="form-check-label" htmlFor="flexRadioDefault1">{t('emandate')}</label>
        //                                 </div>
        //                                 <div className="circleborder">    <img src={EMandate} /> </div>
        //                             </div>
        //                         </div>}
        //                         {mandateData?.aadhaar_mandate && <div className="col-12 mb-3">
        //                             <div className="d-flex justify-content-between align-items-center UPI_Mandate">
        //                                 <div className="form-check">
        //                                     <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('aadhaar-mandate') }} />
        //                                     <label className="form-check-label" htmlFor="flexRadioDefault1">{t('aadhaarmandate')}</label>
        //                                 </div>
        //                                 <div className="circleborder">   <img src={AadhaarMandate} /> </div>
        //                             </div>
        //                         </div>}
        //                         {mandateData?.physical_mandate && <div className="col-12 mb-3">
        //                             <div className="d-flex justify-content-between align-items-center UPI_Mandate">
        //                                 <div className="form-check">
        //                                     <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('test-p-mandate') }} />
        //                                     <label className="form-check-label" htmlFor="flexRadioDefault1">Physical Mandate</label>
        //                                 </div>
        //                                 <div className="circleborder">   <img src={PhysicalMandate} /> </div>
        //                             </div>
        //                         </div>}
        //                     </div>
        //                     <div className='row'>
        //                         <div className="col-12">
        //                             <button className="btn btn-primary w-100 Proceed_btn" type='button' onClick={checkOpt}>Proceed</button>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
        <>
        {loader && <Loader/>}
        {!loader && <div class="container in-spacer">
            <div class="row">
                <div class="col-12">
                    <h6 class="mb-3">Select mandate registration type</h6>
                </div>
                {mandateData?.upi_mandate &&
                    <div class="col-lg-6 col-sm-6 col-12">
                        <div class="d-flex justify-content-between align-items-center UPI_Mandate mb-3"
                            >
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="flexRadioDefault" id="UPI_radio" onClick={() => { setType('upi-mandate') }} />
                                <label class="form-check-label" for="flexRadioDefault1">UPI Mandate</label>
                            </div>
                            <div class="circleborder"> <img src={UpiMandate} /></div>
                        </div>
                    </div>}
                {mandateData?.e_mandate &&
                    <div class="col-lg-6 col-sm-6 col-12">
                        <div class="d-flex justify-content-between align-items-center UPI_Mandate mb-3"
                            >
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="flexRadioDefault" id="E_radio" onClick={() => { setType('e-mandate') }} />
                                <label class="form-check-label" for="flexRadioDefault1">E Mandate</label>
                            </div>
                            <div class="circleborder"> <img src={EMandate} /> </div>
                        </div>
                    </div>}
                {mandateData?.aadhaar_mandate && <div class="col-lg-6 col-sm-6 col-12">
                    <div class="d-flex justify-content-between align-items-center UPI_Mandate mb-3"
                        >
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="Aadhar_radio" onClick={() => { setType('aadhaar-mandate') }} />
                            <label class="form-check-label" for="flexRadioDefault1">Aadhaar Mandate</label>
                        </div>
                        <div class="circleborder"> <img src={AadhaarMandate} /> </div>
                    </div>
                </div>}
                {mandateData?.physical_mandate && <div class="col-lg-6 col-sm-6 col-12">
                    <div class="d-flex justify-content-between align-items-center UPI_Mandate mb-3"
                        >
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="Physical_radio" onClick={() => { setType('web-p-mandate') }} />
                            <label class="form-check-label" for="flexRadioDefault1">Physical Mandate</label>
                        </div>
                        <div class="circleborder"> <img src={PhysicalMandate} /> </div>
                    </div>
                </div>}
                {showErr &&
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                        <p class="mb-1">{showErr}</p>
                        <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">&#215;</button>
                    </div>
                }
                {type && <div class="col-12 mb-3">
                    <div class="row">
                        <div class="col-lg-4 col-sm-6 mb-3">
                            <button class="btn Proceed_btn w-100" type="button" disabled={!type}
                                onClick={checkOpt}>Proceed</button>
                        </div>
                    </div>
                </div>}
            </div>
            <div class="row">
                <div class="col-12">
                    <nav class="navbar MenuTop fixed-top navbar-expand-lg navstyles">
                        <div class="container">
                            <a class="navbar-brand-sm" href="#">
                                <img src={cholaLogo} alt="Chola Logo" />
                            </a>
                            <ul class="nav-list">
                                <li class="nav-item">
                                    {/* <a class="nav-link" onClick={() => { dispatch(setShowLanguage(true)) }}>
                                        <img src={Lang} />
                                    </a> */}
                                </li>
                                {partner === 'chola-web' && <li>
                                    <a href="#" onClick={logout}>Logout</a>
                                </li>}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>}
        </>
    )
}

export default MandateOpt